import { useFormikContext } from 'formik';

import { ReceiptNoteType } from '../../../common/models/enums/receipt-note-type';
import { SalesOrderDetailFormValues } from '../models/sales-order-detail-form-values';
import { paloDraftNoteIds, usePaloDraftNotices } from '../../../common/components/palo/palo-draft-notices';

/**
 * Asks for the notes of the customer, contacts and articles the form holds,
 * so they stand in the head before the first save (#2236).
 *
 * It draws nothing.
 */
export const PaloSalesOrderNotesWatcher = (): null => {
    const { values } = useFormikContext<SalesOrderDetailFormValues>();
    const positions = values.positions ?? [];

    usePaloDraftNotices(
        ReceiptNoteType.SalesOrders,
        paloDraftNoteIds({
            accountIds: [values.customerAccount?.id],
            contactIds: [
                values.customerContact?.id,
                values.responsibleContact?.id,
                ...positions.flatMap(position => [position.customerContact?.id, position.avisoContact?.id]),
            ],
            productIds: positions.flatMap(position => (position.items ?? []).map(item => item.product?.id)),
        })
    );

    return null;
};
